import React from "react";
import AppStyles from "../../config/styles";
import "../../styles/Home.css";

const styles = {
inputstyle: {
    marginLeft: "10px",
    marginRight: "15px",
    alignSelf: "center",
    fontFamily: "Lato",
    fontSize: "14px",
    color: AppStyles.colors.COLOR_BLACK,
    width: "75%",
    // borderRadius: "50%"
  },
};

export default function SearchView(props) {
    const searchCallHandler=(e)=>{
        props.searchCallBack(e.target.value)
    }
  if (props.enableSerach) {
    return (
      <div className="container searchstyle" >
        {props.icon}
        <input 
          type = "text"
          value={props?.searchText}
          placeholder={props.placeholderText}
          style={{...styles.inputstyle, ...props?.inputstyle}}
          onChange={(e) =>searchCallHandler(e)}
        />
      </div>
    );
  } return null;
}
